import monstersData from '../data/srd_5e_monsters.json';

const ENVIRONMENT_ALIASES = {
  'hill': 'hills',
  'mountain': 'mountains',
  'ruins': 'ruin',
  'caves': 'caverns',
};

function normalizeEnvironments(environments) {
  if (!environments || !Array.isArray(environments)) return [];
  
  const normalized = new Set();
  environments.forEach(env => {
    const lower = env.toLowerCase();
    const consolidated = ENVIRONMENT_ALIASES[lower] || lower;
    normalized.add(consolidated);
  });
  
  return Array.from(normalized);
}

function getArmorClassValue(armorClass) {
  if (!armorClass || !Array.isArray(armorClass) || armorClass.length === 0) {
    return null;
  }
  return armorClass[0].value;
}

function normalizeMonster(monster) {
  return {
    index: monster.index,
    name: monster.name,
    size: monster.size,
    type: monster.type,
    subtype: monster.subtype,
    alignment: monster.alignment,
    cr: monster.challenge_rating,
    xp: monster.xp,
    ac: getArmorClassValue(monster.armor_class),
    hp: monster.hit_points,
    hit_dice: monster.hit_dice,
    speed: monster.speed,
    strength: monster.strength,
    dexterity: monster.dexterity,
    constitution: monster.constitution,
    intelligence: monster.intelligence,
    wisdom: monster.wisdom,
    charisma: monster.charisma,
    senses: monster.senses,
    languages: monster.languages,
    special_abilities: monster.special_abilities,
    actions: monster.actions,
    legendary_actions: monster.legendary_actions,
    reactions: monster.reactions,
    img: monster.image,
    environments: normalizeEnvironments(monster.environments),
    popularity: monster.popularity || 0,
    role: monster.role || 'soldier',
  };
}

function shuffle(array) {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

const allMonsters = monstersData.map(normalizeMonster);

const availableEnvironments = (() => {
  const envSet = new Set();
  allMonsters.forEach(m => {
    m.environments.forEach(env => {
      // Don't include "any" as a selectable environment
      if (env !== 'any') {
        envSet.add(env);
      }
    });
  });
  return Array.from(envSet).sort();
})();

export function getMonstersByCRRange(minCR, maxCR, environments = null) {
  let filtered = allMonsters.filter(m => m.cr >= minCR && m.cr <= maxCR);
  
  if (environments) {
    // Support both single string and array of environments
    const envList = Array.isArray(environments) ? environments : [environments];
    const envLowerSet = new Set(envList.map(e => e.toLowerCase()));
    
    filtered = filtered.filter(m => 
      // Include if monster has "any" environment or matches a selected environment
      m.environments.includes('any') ||
      m.environments.some(env => envLowerSet.has(env))
    );
  }
  
  return shuffle(filtered);
}

export function getMonsterDetails(index) {
  return allMonsters.find(m => m.index === index) || null;
}

/** Full SRD record (API shape) for stat blocks — includes proficiencies, raw armor_class, etc. */
export function getMonsterRawByIndex(index) {
  if (!index) return null;
  return monstersData.find((m) => m.index === index) ?? null;
}

export function getAllMonsters() {
  return [...allMonsters];
}

export function getAvailableEnvironments() {
  return availableEnvironments;
}
